
export const Media = [

    { type: 'image', url: require('./BlackGalaxy.jpg'), title:'Black Galaxy'},
    { type: 'image', url: require('./Steelgrey.jpg'), title: 'Steel Grey' },
    { type: 'image', url: require('./Blackperal.jpg'),title:'Black Pearl' },
    { type: 'image', url: require('./Absoluteblack.jpg'), title: 'Absolute Black' },
    { type: 'image', url: require('./Visconwhite.jpg'), title: 'Viscon White' },
    { type: 'image', url: require('./Revierwhite.jpg'), title: 'River White' },
    { type: 'image', url: require('./Moonwhite.jpg'), title: 'Moon  White' },
    { type: 'image', url: require('./Oceanwhite.jpeg'), title: 'Ocean White' }, 

    { type: 'image', url: require('./Forestwhite.jpg'), title: 'Forest White' },
    { type: 'image', url: require('./Pwhite.jpg'), title: 'P-White' },
    { type: 'image', url: require('./Lavender-Blue.jpg'), title: 'Lavender Blue' },
    { type: 'image', url: require('./bash-paradiso.jpg'), title: 'bash Paradiso' },
    { type: 'image', url: require('./Astoria.jpg'), title: 'Astoria' },
    { type: 'image', url: require('./Colonial-Gold.jpg'), title: 'Colonial Gold' },
    { type: 'image', url: require('./imperial-gold.jpg'), title: 'imperial Gold' },
    // { type: 'image', url: require('./Unknow.jpg'), title: 'Unknow' },

    { type: 'image', url: require('./Chilli-red.jpeg'), title: 'Chilli Red' },
    { type: 'image', url: require('./Ruby-red.jpg'), title: 'Ruby Red' },
    { type: 'image', url: require('./NO.jpg'), title: 'Red Multi' },
    { type: 'image', url: require('./NO-1.jpeg'), title: 'New imperial Red' },

    { type: 'image', url: require('./Astoria.jpg'), title: 'Astoria' },
    // { type: 'image', url: require('./Colonial-Gold.jpg'), title: 'Colonial-Gold' },
    // { type: 'image', url: require('./imperial-gold.jpg'), title: 'imperial-gold' },
    { type: 'image', url: require('./Unknow.jpg'), title: 'Icon Brown' },

    { type: 'image', url: require('./Vizag-blue.jpeg'), title: 'Vizag Blue' },
    { type: 'image', url: require('./Silver-wave.jpg'), title: 'Silver Wave' },
    { type: 'image', url: require('./Indian-auraro.jpg'), title: 'Indian Auraro' },
    { type: 'image', url: require('./Tan-brown.jpg'), title: 'Tan Brown' },

    { type: 'image', url: require('./Indian-black.jpg'), title: 'Indian Black' },
    { type: 'image', url: require('./Black-Forest.jpg'), title: 'Black Forest' },
    // { type: 'image', url: require('./Indian-auraro.jpg'), title: 'Indian-Auraro' },
    // { type: 'image', url: require('./Tan-brown.jpg'), title: 'Tan-brown' },
]

